import React, { ReactElement } from 'react'

import { Trans } from '@lingui/macro'

import { config } from '../../../../../../../../config'
import { Text } from '../../../../styled'
import { Link } from '../../styles'

const TAUROMARKET_LINK = config.urls.frontendUrl

export function TauroLegalInfo(): ReactElement {
  return (
    <>
      <Text textAlign="left">
        <Trans>
          Tauro Markets (<Link href={TAUROMARKET_LINK}>TAUROMARKETS.COM</Link>) is the trading name owned by JM
          Financial Services Co. Which is authorized by the Ministry of Commerce in the State of Kuwait bearing
          registration No. 355893. and registered office: Qibla, Abdullah Al Mubarak, Al Enmaa’ Tower, 15 Floor, Kuwait
          City, Kuwait.
        </Trans>
      </Text>
      <Text textAlign="left">
        <Trans>
          Tauro Markets (<Link href={TAUROMARKET_LINK}>TAUROMARKETS.COM</Link>) is the trading name operated by JM
          Financial L.L.C , JM Financial LLC is a brokerage services firm providing Forex & CFD trading. The company is
          based in Suite 305, Griffith Corporate Centre, Beachmont, Kingstown, Saint Vincent & the Grenadines
          (Corporation number 2496 LLC 2022).
        </Trans>
      </Text>
    </>
  )
}
